import React from "react";
import styled from "styled-components";
import { Description, H4, H5 } from "./typography";
import { r, getThemeColor } from "../utils";

const List = styled.ul`
  max-width: 25rem;
  width: 100%;
  display: flex;
  ${r("flex-direction", "column", "column")};
  padding-left: 2.5rem;
  margin: 0;
`;

const Item = styled.li`
  font-size: 1.3rem;
  line-height: 1.3;
  padding-bottom: .5rem;
  list-style: none;
  position: relative;
  &:before {
    content: "\0002192";
    position: absolute;
    left: -1.7rem;
    color: ${getThemeColor("teal")};
  }
`;

export default ({ benefits = [] }) =>
  <List>
    {benefits.map(benefit =>
      <Item>
        <H4>
          {benefit.title}
        </H4>
        <Description>
          {benefit.description}
        </Description>
      </Item>
    )}
  </List>;



// WEBPACK FOOTER //
// ./src/components/CvilleList.js